const hiddenClassName = "is-hidden";
const activeClassName = "is-active";
const accordionSlideSpeed = 250;

const collapsedAccordionStyles = {
  height: "0px",
  paddingTop: "0px",
  paddingBottom: "0px",
  marginTop: "0px",
  marginBottom: "0px",
};

const prefersReducedMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const clearAccordionAnimationStyles = (content) => {
  content.style.height = "";
  content.style.paddingTop = "";
  content.style.paddingBottom = "";
  content.style.marginTop = "";
  content.style.marginBottom = "";
  content.style.overflow = "";
  content.style.willChange = "";
  content.style.contain = "";
};

const slideAccordionContent = (content, isOpen, onFinish) => {
  content.accordionAnimation?.cancel();
  content.style.display = "block";
  content.hidden = false;

  const style = window.getComputedStyle(content);
  const expandedAccordionStyles = {
    height: `${content.scrollHeight}px`,
    paddingTop: style.paddingTop,
    paddingBottom: style.paddingBottom,
    marginTop: style.marginTop,
    marginBottom: style.marginBottom,
  };

  content.style.overflow = "hidden";
  content.style.willChange = "height";
  content.style.contain = "layout paint";

  if (typeof content.animate !== "function") {
    clearAccordionAnimationStyles(content);
    content.style.display = isOpen ? "block" : "";
    onFinish();
    return;
  }

  const animation = content.animate(
    isOpen ? [collapsedAccordionStyles, expandedAccordionStyles] : [expandedAccordionStyles, collapsedAccordionStyles],
    { duration: accordionSlideSpeed, easing: "ease", fill: "forwards" },
  );
  content.accordionAnimation = animation;

  animation.finished
    .then(() => {
      clearAccordionAnimationStyles(content);
      content.style.display = isOpen ? "block" : "";
      animation.cancel();
      onFinish();
    })
    .catch(() => {});
};

const getPanelFromLink = (link) => {
  const selector = link.getAttribute("href");
  if (!selector?.startsWith("#")) {
    return null;
  }

  return document.querySelector(selector);
};

const setPanelState = (link, panel, isActive) => {
  const title = link.closest(".tabs-title");
  title?.classList.toggle(activeClassName, isActive);
  link.setAttribute("aria-selected", String(isActive));

  if (panel) {
    panel.classList.toggle(activeClassName, isActive);
    panel.classList.toggle(hiddenClassName, !isActive);
    panel.hidden = !isActive;
  }
};

const initTabs = () => {
  document.querySelectorAll("[data-tabs]").forEach((tabs) => {
    const links = [...tabs.querySelectorAll('a[href^="#"]')];

    links.forEach((link, index) => {
      const panel = getPanelFromLink(link);
      const isActive = link.closest(".tabs-title")?.classList.contains(activeClassName) || index === 0;
      setPanelState(link, panel, isActive);

      link.addEventListener("click", (event) => {
        event.preventDefault();

        links.forEach((tabLink) => {
          setPanelState(tabLink, getPanelFromLink(tabLink), tabLink === link);
        });

        $(window).trigger("change.zf.tabs");
      });
    });
  });
};

const initAccordions = () => {
  document.querySelectorAll("[data-accordion]").forEach((accordion) => {
    const allowAllClosed = accordion.dataset.allowAllClosed !== undefined;
    const allowMultipleOpen = accordion.dataset.multiExpand !== undefined;
    const items = [...accordion.querySelectorAll("[data-accordion-item]")];

    const setItemState = (item, isOpen, animate = false) => {
      const wasOpen = item.classList.contains(activeClassName);

      if (animate && wasOpen === isOpen) {
        return;
      }

      const title = item.querySelector(".accordion-title");
      const content = item.querySelector("[data-tab-content]");

      item.classList.toggle(activeClassName, isOpen);
      title?.setAttribute("aria-expanded", String(isOpen));

      if (content) {
        content.setAttribute("aria-hidden", String(!isOpen));

        if (animate && !prefersReducedMotion()) {
          if (isOpen) {
            content.classList.add(activeClassName);
            slideAccordionContent(content, true, () => {});
          } else {
            slideAccordionContent(content, false, () => {
              content.classList.remove(activeClassName);
              content.hidden = true;
            });
          }
        } else {
          content.accordionAnimation?.cancel();
          clearAccordionAnimationStyles(content);
          content.classList.toggle(activeClassName, isOpen);
          content.hidden = !isOpen;
          content.style.display = isOpen ? "block" : "";
        }
      }
    };

    items.forEach((item) => {
      setItemState(item, item.classList.contains(activeClassName));

      item.querySelector(".accordion-title")?.addEventListener("click", (event) => {
        event.preventDefault();

        const isOpen = item.classList.contains(activeClassName);
        if (!allowMultipleOpen) {
          items
            .filter((otherItem) => otherItem !== item && otherItem.classList.contains(activeClassName))
            .forEach((otherItem) => setItemState(otherItem, false, true));
        }

        if (!isOpen || allowAllClosed) {
          setItemState(item, !isOpen, true);
        }
      });
    });
  });
};

export { initAccordions, initTabs };